/**
 * 
 * @author Jesus R. Nava Cruz
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

import axios from 'axios';
import ServicePath from "@/core/ServicePath"
import {
    MainRequest
} from "@/core/request";

export default class ConsultingRoomRequest extends MainRequest {

    static addConsultingRoom(data) {
        return this.postSEC(ServicePath.CONSULTING_ROOM_ADD, data)
    }

    static listAllConsultingRoomByBranchOffice(data) {
        return this.postSEC(ServicePath.CONSULTING_ROOM_LIST_ALL, data)
    }

    static allConsultingRoom() {
        return this.getSEC(ServicePath.CONSULTING_ROOM_LIST)
    }

    static updateConsultingRoom(data) {
        return this.postSEC(ServicePath.CONSULTING_ROOM_UPDATE, data)
    }

    static deleteConsultingRoom(data) {
        return this.postSEC(ServicePath.CONSULTING_ROOM_DELETE, data)
    }
    
    static statusConsultingRoom(data){
        return this.postSEC(ServicePath.CONSULTING_ROOM_STATUS, data)
    }

    static listAllConsultingRoomById(data) {
        return this.postSEC(ServicePath.CONSULTING_ROOM_LIST_BY_ID, data)
    }

    static listAllConsultingRoomByModalty(data) {
        return this.postSEC(ServicePath.CONSULTING_ROOM_LIST_BY_MODALTY, data)
    }

    static allConsultingRoomModality(data){
        return this.postSEC(ServicePath.CONSULTING_ROOM_MODALITY_ALL, data)
    }

    static addConsultingRoomModality(data){
        return this.postSEC(ServicePath.CONSULTING_ROOM_MODALITY_ADD, data)
    }

    static deleteConsultingRoomModality(data){
        return this.postSEC(ServicePath.CONSULTING_ROOM_MODALITY_DELETE, data)
    }

}